import { render, staticRenderFns } from "./Accesibilidad.vue?vue&type=template&id=009ae4ba&scoped=true&lang=pug&"
import script from "./Accesibilidad.vue?vue&type=script&lang=js&"
export * from "./Accesibilidad.vue?vue&type=script&lang=js&"
import style0 from "./Accesibilidad.vue?vue&type=style&index=0&id=009ae4ba&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009ae4ba",
  null
  
)

export default component.exports